import { useContext } from "react";
import "react-international-phone/style.css";
import { PhoneInput } from "react-international-phone";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import RequestQuoteFormContext from "./RequestQuoteFormContext";
import { useState } from "react";

const Contact = () => {
	const { contact, setContact, next, prev } = useContext(
		RequestQuoteFormContext,
	);

	const handleChange = (first, second) => {
		if (second && second.name) {
			setContact((prev) => ({
				...prev,
				[second.name]: first,
			}));
		} else if (second?.inputValue) {
			setContact((prev) => ({
				...prev,
				phone_number: second.inputValue,
			}));
		} else if (first?.target) {
			const { name, value } = first.target;
			setContact((prev) => ({ ...prev, [name]: value }));
		}
	};

	const [errors, setErrors] = useState({});

	const handleSubmit = (e) => {
		e.preventDefault();
		const newErrors = {};
		const phone = contact.phone_number;


		if (!contact.full_name || contact.full_name.trim() === "") {
			newErrors.full_name = "Full name is required.";
		}
		if (
			!phone ||
			contact.phone_number.trim() === "" ||
			parsePhoneNumberFromString(phone).isValid() === false
		) {
			newErrors.phone_number = "Valid phone number is required.";
		}
		if (
			!contact.email_address ||
			contact.email_address.trim() === "" ||
			!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email_address)
		) {
			newErrors.email_address = "Valid email address is required.";
		}

		setErrors(newErrors);

		if (Object.keys(newErrors).length > 0) {
			console.error("Validation errors:", newErrors);
			return;
		}

		next();
	};

	return (
		<form className="w-full" onSubmit={(e) => e.preventDefault()}>
			{/* Full Name */}
			<div className="flex flex-col gap-1 mb-4">
				<label className="text-xs uppercase tracking-widest text-slate-400 font-medium">
					Full name
				</label>
				<input
					type="text"
					name="full_name"
					value={contact.full_name}
					onChange={handleChange}
					placeholder="Jane Smith"
					className="border border-slate-200 rounded-sm px-3 py-2 text-sm text-slate-900 placeholder:text-slate-300 focus:outline-none focus:border-brand-500 transition-colors"
				/>
				{errors?.full_name && (
					<span className="text-red-400 text-xs">{errors.full_name}</span>
				)}
			</div>

			{/* Phone Number */}
			<div className="flex flex-col gap-1 mb-4">
				<label className="text-xs uppercase tracking-widest text-slate-400 font-medium">
					Phone number
				</label>
				<PhoneInput
					defaultCountry="ae"
					disableFormatting={true}
					name="phone_number"
					value={contact.phone_number}
					onChange={handleChange}
					className="border border-slate-200 rounded-sm text-sm focus-within:border-brand-500 transition-colors"
					style={{
						"--react-international-phone-border-radius": "2px",
						"--react-international-phone-border-color": "transparent",
						"--react-international-phone-background-color": "transparent",
						"--react-international-phone-height": "38px",
						"--react-international-phone-font-size": "0.875rem",
					}}
				/>
				{errors?.phone_number && (
					<span className="text-red-400 text-xs">{errors.phone_number}</span>
				)}
			</div>

			{/* Email */}
			<div className="flex flex-col gap-1 mb-8">
				<label className="text-xs uppercase tracking-widest text-slate-400 font-medium">
					Email address
				</label>
				<input
					type="email"
					name="email_address"
					value={contact.email_address}
					onChange={handleChange}
					placeholder="jane@example.com"
					className="border border-slate-200 rounded-sm px-3 py-2 text-sm text-slate-900 placeholder:text-slate-300 focus:outline-none focus:border-brand-500 transition-colors"
				/>
				{errors?.email_address && (
					<span className="text-red-400 text-xs">{errors.email_address}</span>
				)}
			</div>

			{/* Navigation */}
			<div className="grid grid-cols-2 gap-3">
				<button
					onClick={prev}
					className="py-2.5 border border-slate-200 ha:border-slate-400 text-slate-600 ha:text-slate-900 text-sm font-medium tracking-wide transition-all rounded-sm active:scale-[0.99]"
				>
					← Back
				</button>
				<button
					onClick={handleSubmit}
					className="py-2.5 bg-brand-500 ha:bg-brand-600 text-white text-sm font-medium tracking-wide transition-all rounded-sm active:scale-[0.99]"
				>
					Continue →
				</button>
			</div>
		</form>
	);
};
export default Contact;
